export interface PedidoPedidoOptionsActions {
    canEdit: boolean;
    canConsultar: boolean;
    canConfirmar: boolean;
    canExportOneErp: boolean;
    canEnviarEmail: boolean;
    canPrint: boolean;
    canDuplicate: boolean;
    canLiberar: boolean;
    canIniciarAguardandoProducao: boolean;
    canTerminarAguardandoProducao: boolean;
    canLiberarExpedicao: boolean;
    canCancelar: boolean;
    canImportOneEcommerce: boolean;
    canImportOneErp_v1: boolean;
    canImportOneErp: boolean;
    canOpenRetornoAmostras: boolean;

    // Orçamento
    canSolicitarRevisao: boolean;
    canRevisar: boolean;
    canConfirmarPCP: boolean;
    // Proposta Comercial
    canPrintPropostaComercial: boolean;
    canSendEmailPropostaComercial: boolean;
    canRetornarAnaliseCliente: boolean;
}

export class PedidoPedidoOptions implements PedidoPedidoOptionsActions {
    canEdit: boolean;
    canConsultar: boolean;
    canConfirmar: boolean;
    canExportOneErp: boolean;
    canEnviarEmail: boolean;
    canPrint: boolean;
    canDuplicate: boolean;
    canLiberar: boolean;
    canIniciarAguardandoProducao: boolean;
    canTerminarAguardandoProducao: boolean;
    canLiberarExpedicao: boolean;
    canCancelar: boolean;
    canImportOneEcommerce: boolean;
    canImportOneErp_v1: boolean;
    canImportOneErp: boolean;
    canOpenRetornoAmostras: boolean;

    // Orçamento
    canSolicitarRevisao: boolean;
    canRevisar: boolean;
    canConfirmarPCP: boolean;
    // Proposta Comercial
    canPrintPropostaComercial: boolean;
    canSendEmailPropostaComercial: boolean;
    canRetornarAnaliseCliente: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.canEdit ||
                this.canConsultar ||
                this.canConfirmar ||
                this.canExportOneErp ||
                this.canEnviarEmail ||
                this.canPrint ||
                this.canDuplicate ||
                this.canLiberar ||
                this.canIniciarAguardandoProducao ||
                this.canTerminarAguardandoProducao ||
                this.canLiberarExpedicao ||
                this.canCancelar ||
                this.canImportOneEcommerce ||
                this.canImportOneErp_v1 ||
                this.canImportOneErp ||
                this.canOpenRetornoAmostras ||

                // Orçamentos
                this.canSolicitarRevisao ||
                this.canRevisar ||
                this.canConfirmarPCP ||
                // Proposta Comercial
                this.hasAnyOptionPropostaComercial();

    }

    /** Verifica se possui alguma opção das propostas comericais habilitado */
    hasAnyOptionPropostaComercial(): boolean {
        return this.canPrintPropostaComercial ||
                this.canSendEmailPropostaComercial ||
                this.canRetornarAnaliseCliente;
    }
}
